import { Injectable } from '@angular/core';
import { ApiService } from './api';
import { MediaItem } from 'src/models/media-item';
import { LoadingController } from '@ionic/angular';

@Injectable({
    providedIn: 'root'
})
export class ImageService {
    constructor(
        private api: ApiService,
        private loadingCtrl: LoadingController) { }

    async uploadImage(fileData, fileName, privateImage: boolean) {
        const loader = await this.loadingCtrl.create({
            message: 'Uploading image...'
        });
        await loader.present();

        try {
            const formData = new FormData();
            formData.append('file', fileData, fileName);

            return await this.api.postWithAuth<string>(
                `${this.api.endpoints.images}/upload?privateFile=${privateImage}`,
                formData,
                false,
                'text'
            );
        } catch (err) {
            console.error(err);
            throw err;
        } finally {
            await loader.dismiss();
        }
    }
    
    async uploadDocument(fileData, fileName, accountId: number) {
        const loader = await this.loadingCtrl.create({
            message: 'Uploading document...'
        });
        await loader.present();

        try {
            const formData = new FormData();
            formData.append('file', fileData, fileName);
                //upload secure document
                return await this.api.postWithAuth<string>(
                    `${this.api.endpoints.images}/uploadPrivateAccountDocument?fileName=${fileName}&accountId=${accountId}`,
                    formData,
                    false,
                    'text'
                );
        } catch (err) {
            console.error('imageService.uploadDocument.55', err);
            throw err;
        } finally {
            await loader.dismiss();
        }
    }

    async uploadRunVideo(fileData, runId, fileName) {
        const formData = new FormData();
        formData.append('file', fileData, fileName);
        return await this.api.postWithAuth(
            this.api.endpoints.images + '/uploadRunVideo?runId=' + runId,
            formData);
    }

    async uploadRunPhoto(file, fileName, runId): Promise<MediaItem> {
        const formData = new FormData();
        formData.append('file', file, fileName);

        return await this.api.postWithAuth<MediaItem>(
            this.api.endpoints.images + '/uploadRunPhoto?runId=' + runId,
            formData);
    }

    async updatePhoto(photo) {
        return await this.api
            .putWithAuth(this.api.endpoints.images + '/update', photo);
    }

    async downloadPrivateImage(fileName) {
        return await
            this.api
                .getWithAuth(this.api.endpoints.images + '/getPrivateImage?fileName=' + fileName);
    }

    async deleteImage(fileName, privateFile: boolean) {
        return await
            this.api
                .postWithAuth(this.api.endpoints.images + '/deleteImage?fileName=' + fileName + '&privateFile=' + privateFile);
    }

    async getPrivateAccountDoc(fileName: string, accountId: number): Promise<{ url: string }> {
        return await
            this.api
                .getWithAuth(this.api.endpoints.images + '/getPrivateAccountDocument?fileName=' + fileName + '&accountId=' + accountId);
    }
}
